import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeneralHelper } from 'src/app/helpers/general-helper';

// TODO use this component wherever time budgets can be edited
@Component({
  selector: 'time-budget-picker',
  templateUrl: './time-budget-picker.component.html',
  styleUrls: ['./time-budget-picker.component.scss']
})
export class TimeBudgetPickerComponent {
  @Input()
  hourBudget: number;

  @Input()
  minuteBudget: number;

  @Output()
  hourChange = new EventEmitter<number>();

  @Output()
  minuteChange = new EventEmitter<number>();

  hours = GeneralHelper.hours;
  minutes = GeneralHelper.minutes;

  compareNumbers(n1, n2): boolean {
    return n1 == n2;
  }

  setHours(value: number): void {
    this.hourChange.emit(value);
  }

  setMinutes(value: number): void {
    this.minuteChange.emit(value);
  }
}
